// TODO: Document it

const getLocalFileUrl = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const url = event.target.result;
      resolve(url);
    }
    reader.readAsDataURL(file);
  });
};

export { getLocalFileUrl };
